import React from "react";
import Home from "./Pages/Home";
import "./App.css";
import { CookieSetting } from "cookiesetting-component";

function App() {
  return (
    <>
      <Home />
      <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
        />
   </>
  );
}

export default App;